import LinkModalGroupCustomPath from './LinkModalGroupCustomPath';

export default LinkModalGroupCustomPath;
